// `mypage_next` is the rewrite (../mypage-ui-next), behind the `mypageNext`
// feature. NO has cut over, so its production `mypage_next` is me.evofitness.no.
// The other markets are still under test: their production `mypage_next` is NOT
// me.evofitness.* — that is still legacy until cutover — but the staff pre-prod
// hosts, which run on the production cluster against production APIs behind a
// basic-auth gate.
const defaultConfig = {
  mypage: {
    url: 'https://mypage-ui-de.staging.credlock.net'
  },
  mypage_next: {
    url: 'https://mypage-next-de.staging.credlock.net'
  }
}

const localhostConfig = {
  mypage: {
    url: 'http://localhost:3003'
  },
  mypage_next: {
    url: 'http://localhost:5173'
  }
}

const atConfig = {
  mypage: {
    url: 'https://me.evofitness.at'
  },
  mypage_next: {
    url: 'https://mypage-next-at.production.credlock.net'
  }
}

const norwayConfig = {
  mypage: {
    url: 'https://me.evofitness.no'
  },
  mypage_next: {
    url: 'https://me.evofitness.no'
  }
}

const chConfig = {
  mypage: {
    url: 'https://me.evofitness.ch'
  },
  mypage_next: {
    url: 'https://mypage-next-ch.production.credlock.net'
  }
}

const deConfig = {
  mypage: {
    url: 'https://me.evofitness.de'
  },
  mypage_next: {
    url: 'https://mypage-next-de.production.credlock.net'
  }
}

const stagingConfig = {
  '5336003e-0105-4402-809f-93bf6498af34': {
    mypage: {
      url: 'https://mypage-ui-no.staging.credlock.net'
    },
    mypage_next: {
      url: 'https://mypage-next-no.staging.credlock.net'
    }
  },
  '051b413f-0245-4e84-9228-f3c7c5f8d299': {
    mypage: {
      url: 'https://mypage-ui-at.staging.credlock.net'
    },
    mypage_next: {
      url: 'https://mypage-next-at.staging.credlock.net'
    }
  },
  '4de2a7cb-bd28-4111-aa28-4bbcdf60f533': {
    mypage: {
      url: 'https://mypage-ui-ch.staging.credlock.net'
    },
    mypage_next: {
      url: 'https://mypage-next-ch.staging.credlock.net'
    }
  },
  'c04bc7c3-903f-4804-a952-9abc0016b824': {
    mypage: {
      url: 'https://mypage-ui-de.staging.credlock.net'
    },
    mypage_next: {
      url: 'https://mypage-next-de.staging.credlock.net'
    }
  }
}

// In production, My Pages follows the member's own operator, not the admin host.
const productionConfig = {
  '5336003e-0105-4402-809f-93bf6498af34': norwayConfig,
  '051b413f-0245-4e84-9228-f3c7c5f8d299': atConfig,
  '4de2a7cb-bd28-4111-aa28-4bbcdf60f533': chConfig,
  'c04bc7c3-903f-4804-a952-9abc0016b824': deConfig
}

const productionHosts = [
  'admin.evofitness.at',
  'admin.evofitness.no',
  'admin.evofitness.ch',
  'admin.evofitness.de'
]

const selectConfig = (operator) => {
  const hostname = window.location.hostname
  if (hostname === 'localhost') {
    return localhostConfig
  }
  if (productionHosts.includes(hostname) && operator && productionConfig[operator]) {
    return productionConfig[operator]
  }
  if (hostname === 'admin.evofitness.at') {
    return atConfig
  }
  if (hostname === 'admin.evofitness.no') {
    return norwayConfig
  }
  if (hostname === 'admin.evofitness.ch') {
    return chConfig
  }
  if (hostname === 'admin.evofitness.de') {
    return deConfig
  }
  if (operator && stagingConfig[operator]) {
    return stagingConfig[operator]
  }
  return defaultConfig
}

module.exports = selectConfig
